import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import SetupAuthApp from './setupAuthApp';
import IconComponent from '../../portal/iconComponent';

@inject('translationsStore', 'authStore', 'changePasswordStore') @observer
export default class SetupAuthAppContainer extends Component {
    componentWillMount() {
    }

    render() {

        return (
            <div className='change-password-main-wrapper' data-cy='change-password-screen'>
                <div className='logo-wrapper' style={{ top:'0px', left:'0px' }}>
                    <IconComponent iconClassName='cx-logo-and-text-icon' />
                </div>
                <div>
                    <SetupAuthApp isMyProfileMode={false}/>
                </div>
            </div>
        );
    }
}
